import styled from 'styled-components';

export const Cover = styled.div`
    position: relative;
    width: 100%;
    height: 0px;
    padding-bottom: 100%;
    background-size: cover;
    background-position: center center;
    display: inline-block;
`;

export const Main = styled.div`
    overflow: hidden;
    padding-bottom: 10px;
`;

export const StyleSlider = styled.div`
    width: 274px;
    opacity: 1;
    transform: translate3d(0px, 0px, 0px);
`;
